import React from 'react';
import { Male, Female, HelpOutline } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { genderColors } from '../../utils/colorHandler';

type GenderChipProps = {
  value?: string | null;
};

// Gender shown as a single bigger colored icon: male (blue), female (pink),
// and a neutral "?" for undefined/other. Tooltip carries the readable label.
const GenderChip: React.FC<GenderChipProps> = ({ value }) => {
  const key = (value || '').toUpperCase();

  let Icon = HelpOutline;
  let color = '#90a4ae'; // neutral grey — undefined / other
  let title = value || 'Undefined';

  if (key === 'MALE') {
    Icon = Male;
    color = genderColors.MALE;
    title = 'Male';
  } else if (key === 'FEMALE') {
    Icon = Female;
    color = genderColors.FEMALE;
    title = 'Female';
  }

  return (
    <Tooltip title={title}>
      <Icon sx={{ fontSize: 26, color }} />
    </Tooltip>
  );
};

export default GenderChip;
